import { call, put, takeLatest } from "redux-saga/effects";
import {
  bonusInitRequest,
  bonusInitSuccess,
  bonusInitFailure,
  collectBonusRequest,
  collectBonusSuccess,
  collectBonusFailure,
} from "./bonusActions";
import { getBonus, collectBonus } from "../../services/api";

import { AxiosResponse } from "axios";
import { profileRequest } from "../auth/authActions";

function* initBonusWorker() {
  try {
    const res: AxiosResponse = yield call(getBonus);

    const bonus = res?.data;

    if (bonus) {
       yield put(bonusInitSuccess({ bonus }));
    } else {
      yield put(bonusInitFailure("Package not found"));
    }
  } catch (e: any) {
    console.log("[saga] package error:", e);
    const msg =
      e?.message || e?.response?.data?.error || "Failed to load package";
    yield put(bonusInitFailure(msg));
  }
}

function* collectBonusWorker() {
  try {
    console.log('[saga] Collecting bonus...');
    const res = yield call(collectBonus);
    const chips = Number(res?.data?.chips ?? 0);
    
    console.log('[saga] Bonus collected:', chips, 'chips');
    
    yield put(collectBonusSuccess({ chips }));
    console.log('[saga] Refreshing profile...');
    yield put(profileRequest());
    yield call(delay, 500);
    console.log('[saga] Refreshing bonus data...');
    yield put(bonusInitRequest());
    
  } catch (e: any) {
    console.error('❌ [saga] Collect bonus error:', e);
    yield put(collectBonusFailure(e?.message || "Collect failed"));
  }
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function* bonusRootSaga() {
  yield takeLatest(bonusInitRequest.type, initBonusWorker);
  yield takeLatest(collectBonusRequest.type, collectBonusWorker);
}
